import { cssVar, Flex, Box } from '@cad-arc';
import { PropsWithChildren, ReactNode } from 'react';
import {
    FR_PROPERTIES_PANEL_MARGIN_TOP,
    FR_PROPERTIES_PANEL_WIDTH,
    PROPERTIES_PANEL_FOOTER_HEIGHT,
    PROPERTIES_PANEL_MARGIN_TOP,
    PROPERTIES_PANEL_WIDTH,
} from '../../../esri/constants';
import { useApplicationType } from '../../../common/hooks/use-application-type';

export function PanelWrapper({
    testId,
    footerContent,
    children,
}: PropsWithChildren<{ testId: string; footerContent?: ReactNode }>) {
    const { isFirstResponder } = useApplicationType();
    const showFooter = !!footerContent;
    const panelMarginTop = isFirstResponder
        ? FR_PROPERTIES_PANEL_MARGIN_TOP
        : PROPERTIES_PANEL_MARGIN_TOP;
    const panelWrapperHeightOffSet =
        panelMarginTop + (showFooter ? PROPERTIES_PANEL_FOOTER_HEIGHT : 0);

    return (
        <Box data-testid="MAP_PANEL_WRAPPER" height={`calc(100% - ${panelWrapperHeightOffSet}px)`}>
            <Box data-testid={testId} height="100%" overflowY="auto">
                {children}
            </Box>
            {showFooter && (
                <Flex
                    bottom={0}
                    padding={`${cssVar('arc.space.4')} ${cssVar('arc.space.6')}`}
                    position="absolute"
                    justifyContent="center"
                    backgroundColor="surface.accent"
                    borderTopWidth="1px"
                    borderRightWidth="1px"
                    borderColor="border.default"
                    height={PROPERTIES_PANEL_FOOTER_HEIGHT}
                    width={isFirstResponder ? FR_PROPERTIES_PANEL_WIDTH : PROPERTIES_PANEL_WIDTH}
                >
                    {footerContent}
                </Flex>
            )}
        </Box>
    );
}
